/**
 * 已知爬虫 / 外部抓取 UA 具名串（小写匹配）。
 * 原则：fail-open —— 只拦明确自报身份的爬虫；不确定一律放行。
 * 命中后由入口零请求早退（不打任何业务接口）。
 * 本阶段刻意不迁移 Java 里 `!Mozilla/5.0 && ...` 分支，降低误伤。
 *
 * 来源：
 * - 既有 isBlockSpider 名单
 * - 后端 determineCrawler 具名串（baiduspider / bytespider / meta / facebook / GoogleOther 等）
 */
export const KNOWN_CRAWLER_UA_PATTERNS = [
  // 既有前端名单
  'bot.htm',
  'applebot',
  'storebot-google',
  'facebookexternalhit',
  'amazonproductbot',
  // 后端具名串
  'baiduspider',
  'bytespider',
  'meta-externalads',
  'meta-externalagent',
  'facebookscraper',
  'googleother',
  'googlebot-news',
  'python-urllib/2.5',
  'download demon/3.5.0.11',
  'uzbl (webkit 1.3)',
  // TikTok Ads 多图素材抓取（子串同时覆盖 TTAM_Multi_Image / TTAM_Multi_Images）
  'ttam_multi_image'
] as const;

/**
 * 是否命中已知爬虫 UA。
 * @param userAgent 默认取 navigator.userAgent；空字符串返回 false（放行）
 */
export const isKnownCrawlerUA = (userAgent?: string | null): boolean => {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  if (!ua) {
    return false;
  }

  const uaLower = ua.toLowerCase();
  return KNOWN_CRAWLER_UA_PATTERNS.some((pattern) => uaLower.includes(pattern));
};
